// // import React, { useState, useEffect } from "react";
// // import { Link, useLocation } from "react-router-dom";
// // import Loader from "../../loader/loader";

// // function GenrePro() {
// //   const location = useLocation();
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState("");

// //   const data = location.state;

// //   const podcasts = data?.podcasts || [];
// //   const genreName = data?.genreName || "Genre";

// //   const PodcastCard = ({ podcast }) => (
// //     <div className="col-12 col-sm-4 col-lg-3 mb-4">
// //       <div className="live">
// //         <Link
// //           to={`/podcast-episode/${podcast._id}`}
// //           className="live__cover open-video"
// //         >
// //           <img
// //             src={podcast.coverImageUrl}
// //             alt={podcast.title}
// //             className="img-fluid"
// //             onError={(e) => {
// //               e.target.src = "/default-podcast-cover.jpg"; // Fallback image
// //             }}
// //           />
// //         </Link>
// //         <h5 className="live__title">
// //           <Link to={`/podcast-episode/${podcast._id}`}>
// //             {podcast.genre?.name || genreName}
// //           </Link>
// //         </h5>
// //         <h3 className="live__title">
// //           <Link to={`/podcast-episode/${podcast._id}`}>
// //             {podcast.title || "Untitled Podcast"}
// //           </Link>
// //         </h3>
// //         <p className="live__artist">{podcast.artist || "Unknown Artist"}</p>
// //       </div>
// //     </div>
// //   );

// //   useEffect(() => {
// //     window.scrollTo(0, 0);
// //   }, []);

// //   useEffect(() => {
// //     if (data) {
// //       setLoading(false);
// //     } else {
// //       setError("No genre data found. Please go back and try again.");
// //       setLoading(false);
// //     }
// //   }, [data]);

// //   // Show loading state
// //   if (loading) {
// //     return (
// //       <div className="content-inner pb-0 container-fluid" id="page_layout">
// //         <div
// //           className="d-flex justify-content-center align-items-center"
// //           style={{ height: "50vh" }}
// //         >
// //           <div className="spinner-border text-primary" role="status">
// //             <span className="sr-only">Loading...</span>
// //           </div>{" "}
// //         </div>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className="content-inner pb-0 container-fluid" id="page_layout">
// //       {/* Error Message */}
// //       {error && (
// //         <div
// //           className="alert alert-danger alert-dismissible fade show"
// //           role="alert"
// //         >
// //           {error}
// //           <button
// //             type="button"
// //             className="btn-close"
// //             onClick={() => setError("")}
// //           ></button>
// //         </div>
// //       )}

// //       {/* Back Button */}
// //       <div className="row">
// //         <div className="col-12">
// //           <button
// //             className="btn btn-outline-secondary mb-3"
// //             onClick={() => window.history.back()}
// //           >
// //             ← Back
// //           </button>
// //         </div>
// //       </div>

// //       {/* Genre Header */}
// //       <div className="row">
// //         <div className="col-12">
// //           <h2 className="card-title text-capitalize mt-3 mb-4">
// //             {genreName} Podcasts
// //             {podcasts.length > 0 && (
// //               <span className="badge bg-primary ms-2">{podcasts.length}</span>
// //             )}
// //           </h2>
// //         </div>
// //       </div>

// //       {/* Podcasts Grid */}
// //       <div className="row row--grid">
// //         {podcasts.length > 0 ? (
// //           podcasts.map((podcast) => (
// //             <PodcastCard key={podcast._id} podcast={podcast} />
// //           ))
// //         ) : (
// //           <div className="col-12">
// //             <div className="text-center py-5">
// //               <i className="fas fa-podcast fa-3x text-muted mb-3"></i>
// //               <h4 className="text-muted">No Podcasts Found</h4>
// //               <p className="text-muted">
// //                 No podcasts available for {genreName} genre.
// //               </p>
// //               <button
// //                 className="btn btn-primary mt-2"
// //                 onClick={() => window.history.back()}
// //               >
// //                 Browse Other Genres
// //               </button>
// //             </div>
// //           </div>
// //         )}
// //       </div>

// //       {/* Empty state when no data at all */}
// //       {!data && !loading && (
// //         <div className="row">
// //           <div className="col-12">
// //             <div className="text-center py-5">
// //               <i className="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
// //               <h4 className="text-warning">No Data Available</h4>
// //               <p className="text-muted">
// //                 Unable to load genre information. Please try again.
// //               </p>
// //               <Link to="/genres" className="btn btn-primary mt-2">
// //                 Browse Genres
// //               </Link>
// //             </div>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // }

// // export default GenrePro;

// import React, { useState, useEffect } from "react";
// import { Link, useLocation } from "react-router-dom";
// import httpClient from "../../utils/httpClients";

// function GenrePro() {
//   const location = useLocation();
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   const data = location.state;
//   const podcasts = data?.podcasts || [];
//   const genreName = data?.genreName || "Genre";

//   // API CALL: Add all episodes of a podcast to queue with type: "genrepodcast"
//   const addPodcastToQueue = async (podcastId, podcastTitle) => {
//     try {
//       const payload = {
//         action: "addAllToQueue",
//         playlistId: podcastId,
//         type: "genrepodcast"  // As requested
//       };

//       const res = await httpClient.post("/user/queue/queue-controller", payload);

//       if (res.data?.success) {
//         console.log(`All episodes of "${podcastTitle}" added to queue!`);
//         // Optional: Add toast here later
//       }
//     } catch (err) {
//       console.error("Queue error:", err);
//     }
//   };

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   useEffect(() => {
//     if (data) {
//       setLoading(false);
//     } else {
//       setError("No genre data found. Please go back and try again.");
//       setLoading(false);
//     }
//   }, [data]);

//   // UPDATED PodcastCard with Click-to-Queue + Hover Play
//   const PodcastCard = ({ podcast }) => (
//     <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
//       <div className="live">
//         {/* IMAGE CLICK → Add all episodes to queue */}
//         <div
//           className="live__cover position-relative overflow-hidden"
//           style={{ cursor: "pointer", borderRadius: "12px" }}
//           onClick={() => addPodcastToQueue(podcast._id, podcast.title)}
//         >
//           <img
//             src={podcast.coverImageUrl}
//             alt={podcast.title}
//             className="img-fluid w-100"
//             style={{
//               height: "220px",
//               objectFit: "cover",
//               transition: "transform 0.4s ease",
//             }}
//             onError={(e) => {
//               e.target.src = "/default-podcast-cover.jpg";
//             }}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.transform = "scale(1.08)";
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.transform = "scale(1)";
//             }}
//           />

//           {/* HOVER PLAY ICON */}
//           <div
//             className="position-absolute top-50 start-50 translate-middle"
//             style={{
//               opacity: 0,
//               transition: "all 0.3s ease",
//               zIndex: 2,
//               pointerEvents: "none",
//             }}
//             onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
//             onMouseLeave={(e) => (e.currentTarget.style.opacity = 0)}
//           >
//             <div
//               className="bg-success rounded-circle d-flex align-items-center justify-content-center shadow-lg"
//               style={{
//                 width: "64px",
//                 height: "64px",
//                 background: "rgba(29, 185, 84, 0.95)",
//               }}
//             >
//               <i className="fas fa-play text-white" style={{ fontSize: "28px", marginLeft: "4px" }}></i>
//             </div>
//           </div>

//           {/* DARK OVERLAY ON HOVER */}
//           <div
//             className="position-absolute inset-0"
//             style={{
//               background: "rgba(0, 0, 0, 0.5)",
//               opacity: 0,
//               transition: "opacity 0.3s ease",
//             }}
//             onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
//             onMouseLeave={(e) => (e.currentTarget.style.opacity = 0)}
//           ></div>
//         </div>

//         {/* GENRE */}
//         <h5 className="live__title mt-3 mb-1">
//           <Link
//             to={`/podcast-episode/${podcast._id}`}
//             className="text-black text-decoration-none"
//           >
//             {podcast.genre?.name || genreName}
//           </Link>
//         </h5>

//         {/* TITLE */}
//         <h3 className="live__title">
//           <Link
//             to={`/podcast-episode/${podcast._id}`}
//             className="text-black text-decoration-none"
//           >
//             {podcast.title || "Untitled Podcast"}
//           </Link>
//         </h3>

//         <p className="live__artist text-muted small">
//           {podcast.artist || "Unknown Artist"}
//         </p>
//       </div>
//     </div>
//   );

//   if (loading) {
//     return (
//       <div className="content-inner pb-0 container-fluid" id="page_layout">
//         <div
//           className="d-flex justify-content-center align-items-center"
//           style={{ height: "70vh" }}
//         >
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="content-inner pb-0 container-fluid" id="page_layout">
//       {/* Error Alert */}
//       {error && (
//         <div className="alert alert-danger alert-dismissible fade show" role="alert">
//           {error}
//           <button type="button" className="btn-close" onClick={() => setError("")}></button>
//         </div>
//       )}

//       {/* Back Button */}
//       <div className="row">
//         <div className="col-12">
//           <button
//             className="btn btn-outline-light mb-4 px-4 text-black"
//             onClick={() => window.history.back()}
//           >
//             ← Back to Genres
//           </button>
//         </div>
//       </div>

//       {/* Header */}
//       <div className="row mb-4">
//         <div className="col-12">
//           <h1 className="display-5 fw-bold text-black">
//             {genreName} Podcasts
//             <span className="badge bg-success ms-3 fs-6">{podcasts.length}</span>
//           </h1>
//           <p className="text-muted">Click on any podcast image to play all episodes</p>
//         </div>
//       </div>

//       {/* Podcasts Grid */}
//       <div className="row row--grid">
//         {podcasts.length > 0 ? (
//           podcasts.map((podcast) => (
//             <PodcastCard key={podcast._id} podcast={podcast} />
//           ))
//         ) : (
//           <div className="col-12 text-center py-5">
//             <i className="fas fa-podcast fa-4x text-muted mb-4"></i>
//             <h3 className="text-muted">No Podcasts in {genreName}</h3>
//             <p className="text-muted">Try selecting another genre.</p>
//             <button
//               className="btn btn-outline-primary mt-3"
//               onClick={() => window.history.back()}
//             >
//               ← Go Back
//             </button>
//           </div>
//         )}
//       </div>

//       {/* No Data Fallback */}
//       {!data && !loading && (
//         <div className="text-center py-5">
//           <i className="fas fa-exclamation-triangle fa-4x text-warning mb-4"></i>
//           <h3 className="text-warning">No Genre Data</h3>
//           <Link to="/podcast" className="btn btn-primary">
//             Go to Podcasts
//           </Link>
//         </div>
//       )}
//     </div>
//   );
// }

// export default GenrePro;

import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import httpClient from "../../utils/httpClients";
import { usePlayer } from "../../../PlayerContext"; // IMPORTED

function GenrePro() {
  const location = useLocation();
  const navigate = useNavigate();

  // Player Context
  const { isPlaying, currentTrack, togglePlayPause, triggerQueueUpdate } =
    usePlayer();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const data = location.state;
  const podcasts = data?.podcasts || [];
  const genreName = data?.genreName || "Genre";

  // REUSABLE Queue Handler
  const handleQueueAction = async (action, id = null, type = null) => {
    try {
      const payload = { action };

      if (type === "track") {
        payload.playlistId = id;
        payload.type = "track";
      } else {
        payload.trackId = id;
      }

      const res = await httpClient.post(
        "/user/queue/queue-controller",
        payload,
        { skipLoader: true, skipErrorToast: true },
      );

      if (res.data?.success) {
        triggerQueueUpdate(); // REFRESH QUEUE UI
        return true;
      }
      return false;
    } catch (err) {
      console.error("Queue error:", err);
      return false;
    }
  };

  // IMAGE CLICK → Add All Episodes + Navigate
  const playGenrePodcast = async (podcastId, podcastTitle) => {
    try {
      const success = await handleQueueAction(
        "addPlaylistAndPlay",
        podcastId,
        "track",
      );

      if (success) {
        console.log(
          `All episodes of "${podcastTitle}" added to queue & playing!`,
        );
        // Optional: Auto-play first track if not playing
        if (!isPlaying) {
          togglePlayPause();
        }
      } else {
        console.warn("Queue add failed, but still navigating...");
      }

      // Always navigate after attempt
      navigate(`/podcast-episode/${podcastId}/genre-podcast`);
    } catch (err) {
      console.error("Failed to load podcast:", err);
      // navigate(`/podcast-episode/${podcastId}`);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (data) {
      setLoading(false);
    } else {
      setError("No genre data found. Please go back and try again.");
      setLoading(false);
    }
  }, [data]);

  const PodcastCard = ({ podcast }) => (
    <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
      <div className="live">
        {/* IMAGE CLICK → Queue All + Navigate */}
        <div
          className="live__cover position-relative overflow-hidden rounded-3"
          style={{ cursor: "pointer" }}
          onClick={() => playGenrePodcast(podcast._id, podcast.title)}
        >
          <img
            src={podcast.coverImageUrl}
            alt={podcast.title}
            className="img-fluid w-100"
            style={{
              height: "220px",
              objectFit: "cover",
              transition: "all 0.4s ease",
            }}
            onError={(e) => {
              e.target.src = "/default-podcast-cover.jpg";
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.08)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
            }}
          />

          {/* HOVER PLAY ICON */}
          <div
            className="position-absolute top-50 start-50 translate-middle"
            style={{
              opacity: 0,
              transition: "all 0.3s ease",
              zIndex: 2,
              pointerEvents: "none",
            }}
          >
            <div
              className="bg-success rounded-circle d-flex align-items-center justify-content-center shadow-lg"
              style={{
                width: "68px",
                height: "68px",
                background: "rgba(29, 185, 84, 0.95)",
                backdropFilter: "blur(10px)",
              }}
            >
              <i
                className="fas fa-play text-white"
                style={{ fontSize: "30px", marginLeft: "5px" }}
              ></i>
            </div>
          </div>

          {/* DARK OVERLAY */}
          <div
            className="position-absolute inset-0 rounded-3"
            style={{
              background: "rgba(0, 0, 0, 0.6)",
              opacity: 0,
              transition: "opacity 0.3s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = 0)}
          ></div>
        </div>

        {/* TITLE & GENRE → Only Navigate */}
        <h5 className="live__title mt-3 mb-1">
          <Link
            to={`/podcast-episode/${podcast._id}/genre-podcast`}
            className="text-black text-decoration-none fw-medium"
          >
            {podcast.genre?.name || genreName}
          </Link>
        </h5>

        <h3 className="live__title mb-1">
          <Link
            to={`/podcast-episode/${podcast._id}/genre-podcast`}
            className="text-black text-decoration-none fw-bold"
          >
            {podcast.title || "Untitled Podcast"}
          </Link>
        </h3>

        <p className="live__artist text-muted small">
          {podcast.artist || "Unknown Artist"}
        </p>
      </div>
    </div>
  );

  if (loading) {
    return (
      <div className="content-inner pb-0 container-fluid" id="page_layout">
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "70vh" }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="content-inner pb-0 container-fluid" id="page_layout">
      {/* Error */}
      {error && (
        <div
          className="alert alert-danger alert-dismissible fade show"
          role="alert"
        >
          {error}
          <button
            type="button"
            className="btn-close"
            onClick={() => setError("")}
          ></button>
        </div>
      )}

      {/* Back Button */}
      <div className="row mb-3">
        <div className="col-12">
          <button
            className="btn btn-outline-light px-4 text-black"
            onClick={() => window.history.back()}
          >
            ← Back to Genres
          </button>
        </div>
      </div>

      {/* Header */}
      <div className="row mb-5">
        <div className="col-12">
          <h1 className="display-5 fw-bold text-black mb-2">
            {genreName} Podcasts
            <span className="badge bg-success fs-6 ms-3 align-middle">
              {podcasts.length}
            </span>
          </h1>
          <p className="text-muted lead">
            Click any podcast image to{" "}
            <strong>add all episodes to queue</strong> and play
          </p>
        </div>
      </div>

      {/* Grid */}
      <div className="row row--grid">
        {podcasts.length > 0 ? (
          podcasts.map((podcast) => (
            <PodcastCard key={podcast._id} podcast={podcast} />
          ))
        ) : (
          <div className="col-12 text-center py-5">
            <i className="fas fa-podcast fa-5x text-muted mb-4"></i>
            <h3 className="text-muted">No Podcasts Found</h3>
            <p className="text-muted">This genre has no podcasts yet.</p>
            <button
              className="btn btn-outline-primary"
              onClick={() => window.history.back()}
            >
              ← Explore Other Genres
            </button>
          </div>
        )}
      </div>

      {/* No Data */}
      {!data && !loading && (
        <div className="text-center py-5">
          <i className="fas fa-exclamation-triangle fa-4x text-warning mb-4"></i>
          <h3 className="text-warning">No Genre Data</h3>
          <Link to="/podcast" className="btn btn-primary">
            Go to Podcasts
          </Link>
        </div>
      )}
    </div>
  );
}

export default GenrePro;
